import { httpClient } from "../http/httpClient";

export type OffersParams = {
  cpf: string;
};

export type OffersResponse = {
  id: string;
  offers: {
    amount: string;
    installments: string;
    installmentValue: string;
    taxValue: string;
    ensuranceValue: string;
    installmentsList: number[];
  } | null;
  message?: string;
};

export const getOffers = async (payload: OffersParams) => {
  const { data } = await httpClient
    .get<OffersResponse>(`/c6/offers/${payload.cpf}`)
    .catch((error) => {
      throw error?.response?.data || error;
    });

  return data;
};
